"use strict";
// import { LoggerInitService } from '../common/logging/logger_init_service';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
// LoggerInitService.setup();
__exportStar(require("./window_base"), exports);
__exportStar(require("./windows"), exports);
__exportStar(require("./osr_window"), exports);
__exportStar(require("./desktop_window"), exports);
//# sourceMappingURL=index.js.map